import React from 'react';
import './CmsPage.css';

const SectionRenderer = ({ section }) => {
  const { type, data = {} } = section;
  switch (type) {
    case 'hero':
      return (
        <section className="cms-hero" style={data.backgroundImage ? { backgroundImage: `url(${data.backgroundImage})` } : {}}>
          <h1>{data.title}</h1>
          {data.subtitle && <p>{data.subtitle}</p>}
          {data.ctaText && data.ctaLink && (
            <a href={data.ctaLink} className="cms-cta-btn" data-track="button_click">{data.ctaText}</a>
          )}
        </section>
      );
    case 'text':
      return <section className="cms-text" dangerouslySetInnerHTML={{ __html: data.html || '' }} />;
    case 'image':
      return (
        <section className="cms-image-block">
          <img src={data.url} alt={data.alt || ''} />
          {data.caption && <p>{data.caption}</p>}
        </section>
      );
    case 'cta':
      return (
        <section className="cms-cta-block">
          <a href={data.link || '#'} className="cms-cta-btn" data-track="button_click">{data.text || 'Learn More'}</a>
        </section>
      );
    case 'faq':
      return (
        <section className="cms-faq">
          <h2>{data.title || 'FAQ'}</h2>
          {(data.items || []).map((item, i) => (
            <details key={i} className="cms-faq-item">
              <summary>{item.question}</summary>
              <p>{item.answer}</p>
            </details>
          ))}
        </section>
      );
    case 'reviews':
      return (
        <section className="cms-reviews">
          {(data.quotes || data.items || []).map((q, i) => (
            <blockquote key={i}>{typeof q === 'string' ? q : q.text}</blockquote>
          ))}
        </section>
      );
    case 'newsletter':
      return null;
    default:
      return null;
  }
};

const CmsPage = ({ page, fallback = null }) => {
  if (!page) return fallback;
  const sections = [...(page.sections || [])].sort((a, b) => (a.order || 0) - (b.order || 0));
  if (!sections.length) return fallback;
  return (
    <div className="cms-page">
      {sections.map((section) => (
        <SectionRenderer key={section._id || section.order} section={section} />
      ))}
    </div>
  );
};

export default CmsPage;
